import { useGo, useTranslation } from '@refinedev/core';
import { FaCheckCircle } from 'react-icons/fa';
import { PublicTemplate } from '@components/templates/public';
import { Link } from 'react-router-dom';

export const SuccessfulPayment = () => {
    const go = useGo();
    const { translate } = useTranslation();

    return (
        <PublicTemplate navbar={<></>}>
            <div className="h-full flex flex-col items-center justify-center relative bg-[url('/img/config-landscape.svg')] bg-cover bg-center overflow-hidden">
                {/* Decorative elements */}
                <div className="hover:scale-105 transition-all absolute top-0 left-0 z-10 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute top-0 right-0 z-10 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute top-[30%] right-0 translate-x-[80%] w-24 h-24 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute top-[40%] left-0 z-10 translate-x-[70%] w-8 h-8 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute bottom-0 left-0 -translate-x-1/2 translate-y-[25%] w-32 h-32 rounded-full bg-secondary"></div>
                <div className="hover:scale-105 transition-all absolute bottom-0 right-0 z-10 translate-x-1/2 translate-y-[25%] w-20 h-20 rounded-full bg-secondary"></div>
                
                <div className="relative z-20 w-full max-w-4xl px-4">
                    <div className="card bg-base-100/95 backdrop-blur-sm shadow-2xl w-full max-w-2xl mx-auto">
                        <div className="card-body items-center text-center p-8 md:p-12">
                            {/* Logo */}
                            <Link to="https://hachimind.com" className="link mb-8">
                                <figure>
                                    <img className="w-48 md:w-64 hover:scale-105 transition-all" src="/hachimind.svg" alt="Hachi logo" />
                                </figure>
                            </Link>
                            
                            <FaCheckCircle className="h-20 w-20 text-success animate-bounce mb-6" />
                            <h2 className="card-title text-3xl md:text-4xl font-bold mb-4">
                                {translate('page.payment.success.title')}
                            </h2>
                            <p className="text-base-content/70 text-lg md:text-xl mb-8">
                                {translate('page.payment.success.message')}
                            </p>
                            <div className="card-actions">
                                <button
                                    onClick={() => go({ to: '/' })}
                                    className="btn btn-primary btn-lg min-w-[200px]"
                                >
                                    {translate('page.payment.success.return')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PublicTemplate>
    );
};